export default "__VITE_ASSET__BO7u7yIe__"